class User {
    constructor() {
        this.id = null
        this.username = ''
        this.email = ''
        this.name = ''
        this.avatar = ''
        this.password = ''
        this.access_key = ''
        this.telegram_user_id = ''
        this.datetime_telegram_activation = ''
        this.logito = ''
        this.situation = ''
    }

    static get fieldNames() {
        return {
            id: 'ID',
            username: 'Usuário',
            email: 'E-mail',
            name: 'Nome',
            avatar: 'Avatar (URL)',
            password: 'Senha',
            access_key: 'Chave de acesso',
            telegram_user_id: 'ID telegram',
            datetime_telegram_activation: 'Data ativação logito',
            has_logito: 'Logito',
            is_active: 'Situação'
        }
    }

    static get fieldTypes() {
        return {
            id: 'number',
            username: 'text',
            email: 'email',
            name: 'text',
            avatar: 'file',
            password: 'password',
            access_key: 'text',
            telegram_user_id: 'text',
            datetime_telegram_activation: 'datetime-local',
            has_logito: 'switch',
            is_active: 'switch'
        }
    }

    static get visibleFields() {
        return {
            id: true,
            username: true,
            email: true,
            name: true,
            avatar: false,
            access_key: true,
            telegram_user_id: true,
            datetime_telegram_activation: true,
            has_logito: true,
            is_active: true
            // password: false // no ability to show password
        }
    }

    static get editableFields() {
        return {
            // id: false, // omit false
            username: true,
            email: true,
            name: true,
            avatar: true,
            password: true,
            has_logito: false,
            is_active: true
        }
    }
}

export default User

export { User }
